import { Collection } from 'modules/core/lib/mobx-rest'

import Goal from 'modules/goals/store/models/Goal'

class Goals extends Collection<Goal> {
  model() {
    return Goal
  }

  bulkCreate(ownerIds: number[], goalConfigId: number): Promise<any> {
    return this.rpc('bulk_create', {
      goal_config_id: goalConfigId,
      owner_ids: ownerIds,
    })
  }
}

const singleton: Goals = new Goals()

export default singleton
